import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'

import SlashRemover from '../routes/SlashRemover'
import App from './App'
import AppProviders from './providers'

const rootElement = document.getElementById('root')

const element = (
  <AppProviders>
    <SlashRemover />
    <App />
  </AppProviders>
)

const canHydrate =
  rootElement.hasChildNodes() && rootElement.firstElementChild?.hasAttribute?.('data-reactroot')

if (canHydrate) {
  hydrateRoot(rootElement, element)
} else {
  createRoot(rootElement).render(element)
}
